import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/types';

const generic = (state: RootState) => state.client;

export const selectClient = createSelector(generic, (state) => state.client);

export const selectToken = createSelector(generic, (state) => state.token);
